// extracted by mini-css-extract-plugin
module.exports = {"recentPostArea":"RecentPostArea-module--recentPostArea--30DId"};